import { styled } from '@obvio/app'
import { WishlistButton } from '@obvio/template'
import { Grid, GridItem } from '@obvio/ui'

export const ProductTitle = styled.span`
  text-align: initial;
  ${(theme) => theme.truncate};
`

export const Wishlist = styled(WishlistButton)`
  position: static;
  border: none;
  height: auto;
  width: auto;
`

export const GridWrap = styled(Grid)`
  width: 100%;
  text-align: left;
`

export const GridWishlist = styled(GridItem)`
  margin-left: auto;
`

export const Interactive = styled.div`
  position: relative;
  max-height: 100%;
  width: 100%;
`
